module.exports = __webpack_public_path__ + "static/main-aed8fa2d11cbd624b60c7afbf51ae99d.png";